import BaseComponent from '@/components/base';

export default class HairType extends BaseComponent {
  render() {
    this.selectedButton = null;
    return `
    <style>
     .title {
        font-size: 18px;
        line-height: 28px;
        letter-spacing: .54px;
      }
     .text {
        font-size: 16px;
        line-height: 24px;
        letter-spacing: .32px;
      }
      button {
          margin: 5px;
          padding: 10px;
          font-size: 1em;
          color: black;
          background-color: white;
          cursor: pointer;
           border-radius: 10px;
          border-color: #8ae5d3;
          border-style: solid;
        }
        button.selected {
          background-color: #d2eae5;
        }

        button:hover {
          background-color: #d2eae5;
        }
      </style>
      <div class="title">
        Select Your Hair Type
    </div>
    <div>
        ${[
          { text: 'Straight/Wavy', value: 'wavy' },
          { text: 'Curly/Coily', value: 'coily' }
        ]
          .map(
            ({ text, value }) =>
              `<button class="text" value="${value}"> ${text}</button>`
          )
          .join('')}

    </div>
    `;
  }

  afterMount() {
    this.shadowRoot
      .querySelectorAll('button')
      .forEach((button) =>
        button.addEventListener('click', () => this.handleButtonClick(button))
      );
  }

  handleButtonClick(button) {
    if (this.selectedButton) {
      this.selectedButton.classList.remove('selected');
    }

    this.selectedButton = button;
    this.selectedButton.classList.add('selected');

    const selectedValue = this.selectedButton.getAttribute('value');
    this.setAttribute('value', selectedValue);

    this.dispatchEvent(
      new CustomEvent('quizHairTypeChange', {
        detail: { value: selectedValue },
        bubbles: true,
        composed: true
      })
    );

    document.querySelector('buy-once-regimen').enableHairTypes = true;

    const buyOnce = document.querySelector('buy-once-regimen');
    if (
      buyOnce.enableFragrance &&
      buyOnce.enableHairGoals &&
      buyOnce.enableHairTypes
    ) {
      const button2 = buyOnce.shadowRoot.querySelector('button');

      button2.removeAttribute('disabled');
    }
  }
}
